<template>
  <picture v-if="src" :class="$style.picture" data-picture-v="3.1.0">
    <source
      :srcset="`${src}${computedChained ? '&' : '?'}fm=avif`"
      type="image/avif"
    />
    <source
      :srcset="`${src}${computedChained ? '&' : '?'}fm=webp`"
      type="image/webp"
    />
    <img
      :class="[$style.img, imgClass]"
      :src="src"
      :width="width"
      :height="height"
      :alt="alt"
      :loading="loading"
    />
  </picture>
</template>

<script setup lang="ts">
const props = defineProps<{
  imgClass?: string | string[]
  src: string
  alt: string
  width?: string | number
  height?: string | number
  loading?: 'eager' | 'lazy'
}>()

const computedChained = computed(() => {
  const r = new RegExp('[?]', 'g')

  return r.test(props.src)
})
</script>

<style module lang="scss">
.picture {
  display: block;
}

.img {
  max-width: 100%;
  height: auto;
}
</style>
